/** @module Enums */ /** typedoc */

/**
 * Eligibility status for the Monetization DSP bucket, As Monetization is not eligible by default.
 * `Undefined` releases legacy before `MonetizationEligibility` was implemented
 * `Requested` Was undefined and user requested it.
 * `Eligible` Was flagged as eligible by support when approving the release
 * `Rejected` Was flagged as rejected by support when approving the release
 * `Approved` Was Requested & Approved (or marked eligible by support) and sent to dsps
 * `Paused` Release Paused or monetization paused by support or user
 */
export enum MonetizationEligibilityStateEnum {
    Undefined = 'Undefined',
    Requested = 'Requested',
    Eligible = 'Eligible',
    Rejected = 'Rejected',
    Approved = 'Approved',
    Paused = 'Paused'
}
